export default {"src":"/_next/static/image/public/images/logo_aster_secure.ebb0609b1077b6db3cc2a52c814e1e4f.svg","height":28,"width":86};